import React from 'react';
import { Image, Price, StyledHouseTypePrice, Title } from './HouseTypePrice.styles';
import PropTypes from 'prop-types';

const HouseTypePrice = ({ title, value, image, ...rest }) => {
    return (
        <StyledHouseTypePrice {...rest}>
            <Image src={ image } alt={ title } />
            <Title>{ title }</Title>
            <Price>{ parseInt(value).toLocaleString('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0}) }</Price>
        </StyledHouseTypePrice>
    )
}

HouseTypePrice.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired
}

export default HouseTypePrice;